import { isToday, isYesterday } from 'date-fns';
import { FC } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

type DayLabelProps = {
  date: Date;
};

export const DayLabel: FC<DayLabelProps> = (props) => {
  const { date } = props;

  if (isToday(date)) {
    return <FormattedMessage id="encounters.today" defaultMessage="Today" />;
  }

  if (isYesterday(date)) {
    return (
      <FormattedMessage id="encounters.yesterday" defaultMessage="Yesterday" />
    );
  }

  return (
    <FormattedDate value={date} weekday="short" day="numeric" month="short" />
  );
};
